import {TFunction} from 'i18next';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class PersonalHygienePdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (entry) => {
      // TODO: hardcoded id. Feature flag missing.
      const hygieneEntry = entry.getEntryById('64a75a1625bb29fa139b9213');
      const hygieneName = `<b>${hygieneEntry?.name ?? 'n/a'}:</b>`;
      const hygieneValue = this.getEntryValue(hygieneEntry);

      return `${hygieneName}\n${hygieneValue}`;
    };
  }
}
